import { axiosPost } from "../axios";

export const userLogin = async (payload) => {
  const res = await axiosPost({ path: "auth/login-user", payload: payload });
  return res;
};
